import * as pp from 'src/utils/page-params';

export function usePageParams() {
  return pp.usePageParams(pp.configure().add(pp.param('identifier')));
}

export type PageParams = ReturnType<typeof usePageParams>;
